import { VariantProps, cva } from 'class-variance-authority';

export const radioIndicatorContainer = cva(
  [
    'bg-grayscale0',
    'border',
    'flex',
    'items-center',
    'justify-center',
    'border-grayscale300',
    'hover:bg-primary50',
    'hover:border-primaryMain',
    'active:bg-primary200',
    'active:border-primaryMain',
    'group-data-[disabled="true"]:!bg-grayscale50',
    'group-data-[selected="true"]:bg-primary200',
    'group-data-[disabled="true"]:!border-grayscale200',
  ],
  {
    variants: {
      size: {
        small: ['size-16'],
        default: ['size-24'],
      },
      type: {
        checkbox: ['rounded-4'],
        radio: ['rounded-full'],
      },
    },
    defaultVariants: {
      size: 'default',
      type: 'radio',
    },
  },
);

export type RadioIndicatorContainerVariants = VariantProps<
  typeof radioIndicatorContainer
>;

export const radioIndicator = cva(
  [
    'block',
    'rounded-full',
    'bg-primaryMain',
    'hover:bg-primary600',
    'scale-0',
    'transition-transform',
    'duration-100',
    'group-data-[selected="true"]:scale-100',
    'group-data-[disabled="true"]:bg-grayscale300',
  ],
  {
    variants: {
      size: {
        small: ['size-[10px]'],
        default: ['size-16'],
      },
      type: {
        checkbox: ['rounded-4'],
        radio: ['rounded-full'],
      },
    },
    defaultVariants: {
      size: 'default',
      type: 'radio',
    },
  },
);

export type RadioIndicatorVariants = VariantProps<typeof radioIndicator>;
